import React, { useState, useEffect } from "react";
import Modal from "../../../../components/ui/Modal";
import Input from "../../../../components/ui/Input";
import Button from "../../../../components/ui/Button";

// The modal now accepts an optional 'experienceToEdit' prop
const CreateExperienceModal = ({
  isOpen,
  onClose,
  onSave,
  experienceToEdit,
}) => {
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");

  const isEditMode = !!experienceToEdit;

  useEffect(() => {
    if (isEditMode && isOpen) {
      setTitle(experienceToEdit.title);
      setPrice(experienceToEdit.priceETB.toString());
    } else {
      setTitle("");
      setPrice("");
    }
  }, [isOpen, experienceToEdit, isEditMode]);

  const handleSaveClick = () => {
    if (!title || !price) return;

    const experienceData = {
      id: isEditMode ? experienceToEdit.id : Date.now(),
      title,
      priceETB: parseInt(price, 10),
    };
    onSave(experienceData);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isEditMode ? "Edit Experience" : "Add New Experience"}
    >
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">
            Experience Title
          </label>
          <Input
            placeholder="e.g., Personalized Birthday Video"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">
            Price (ETB)
          </label>
          <Input
            type="number"
            placeholder="e.g., 2500"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div>
        <div className="flex justify-end pt-4 space-x-3">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            {isEditMode ? "Save Changes" : "Save Experience"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateExperienceModal;
